import { defineComponent as _defineComponent } from 'vue'
import { GridApi } from 'ag-grid-community';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TablePagination.ts',
  props: {
    gridApi: null,
    isTableLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  gridApi: GridApi;
  isTableLoading: boolean;
};



const currentPage = ref(0);
const totalPages = ref(0);
const totalRows = ref(0);
const pageSize = ref(0);

const updatePagination = () => {
  currentPage.value = props.gridApi.paginationGetCurrentPage();
  totalPages.value = props.gridApi.paginationGetTotalPages();
  totalRows.value = props.gridApi.paginationGetRowCount();
  pageSize.value = props.gridApi.paginationGetPageSize();
};

onMounted(() => {
  updatePagination();
  props.gridApi.addEventListener('paginationChanged', updatePagination);
});

onBeforeUnmount(() => {
  props.gridApi.removeEventListener('paginationChanged', updatePagination);
});

const paginationText = computed(() => {
  const start = pageSize.value * currentPage.value;
  const end = Math.min(totalRows.value, start + pageSize.value);
  return `${end === 0 ? end : start + 1} - ${end} of ${totalRows.value}`;
});

return { __sfc: true,props, currentPage, totalPages, totalRows, pageSize, updatePagination, paginationText }
}

})